// Decisao dela, 03/09 (2a leva do dia, depois de ver a tela real): a Unidade
// vira SELETOR FECHADO -- mas so quando ha embalagem fechada de verdade (a
// Qtd preenchida). Quem vende solto ("un") nunca usa este campo.
//
// As 3 opcoes cobrem 89 dos 2.490 produtos reais (cx 32, fd 42, kg 15). O
// resto de quem JA TEM embalagem fechada com outro nome ("dz", "saco",
// "balde" -- 198 produtos) fica de fora do fechado por decisao dela: o valor
// gravado aparece como opcao extra, e NUNCA se reescreve sozinho.
export const OPCOES_EMBALAGEM_FECHADA = [
  { valor: 'cx', rotulo: 'CX' },
  { valor: 'fd', rotulo: 'FD' },
  { valor: 'kg', rotulo: 'KG' },
  // Pedido dela 14/10: produto vendido so por unidade. Ver ehUnidadeSolta.
  { valor: 'und', rotulo: 'UND' },
] as const

const VALORES_CONHECIDOS: readonly string[] = OPCOES_EMBALAGEM_FECHADA.map((o) => o.valor)

export function ehValorLegado(unidade: string): boolean {
  const limpo = unidade.trim()
  return limpo !== '' && !VALORES_CONHECIDOS.includes(limpo.toLowerCase())
}

export function valorNoSeletor(unidade: string): string {
  const limpo = unidade.trim().toLowerCase()
  return VALORES_CONHECIDOS.includes(limpo) ? limpo : unidade
}

// UND = vendido so por unidade: a ficha mostra apenas o "Valor unitario" (que e
// o preco do produto na tabela), sem Qtd por Emb nem valor da embalagem. So o
// valor do seletor liga isso -- "UN." e os outros legados seguem completos.
export function ehUnidadeSolta(unidade: string): boolean {
  return unidade.trim().toLowerCase() === 'und'
}
